<template>
    <v-card elevation="0">
        <v-card-text
            class="pa-0"
            style="box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7)"
        >
            <v-form ref="formQualifiedList">
                <v-row no-gutters>
                    <v-col cols="8" lg="8" class="px-5 py-3">
                        <v-row no-gutters>
                            <v-col
                                cols="12"
                                lg="12"
                                class="d-flex column align-center"
                            >
                                <v-avatar
                                    color="#255d98"
                                    size="27"
                                    class="d-flex align-center avatar-shadow"
                                >
                                    <span
                                        class="white--text prompt-title-page"
                                        style="font-size: 18px"
                                        >3</span
                                    >
                                </v-avatar>
                                <div class="my-1 prompt-title ml-3">
                                    {{ $t('message.qualifiedApplicants.stepHeader.three') }}
                                </div>
                            </v-col>
                            <v-col cols="6" lg="6" v-if="!acceptForm">
                                <div class="sarabun-18 mt-5">
                                    {{ $t('message.qualifiedApplicants.step3Content') }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col
                        cols="4"
                        lg="4"
                        class="d-flex justify-center"
                        v-if="!acceptForm"
                    >
                        <div>
                            <v-img
                                :src="require('@/assets/image 9.svg')"
                                width="300"
                                class="mb-4 mt-3"
                            />
                        </div>
                    </v-col>
                    <v-col cols="12" lg="12" class="px-5" v-if="acceptForm">
                        <div class="statistic-panel">
                            <div class="statistic statistic--blue">
                                <v-icon class="statistic-icon" size="33.33"
                                    >mdi-calendar-blank</v-icon
                                >
                                <div>
                                    <p class="statistic-caption mb-1">
                                        {{ $t('message.qualifiedApplicants.sheet.academicYear')}}
                                    </p>
                                    <p class="statistic-value mb-0">
                                        {{ semesterYear }}
                                    </p>
                                </div>
                            </div>
                            <div class="statistic statistic--browny">
                                <v-icon class="statistic-icon" size="33.33"
                                    >mdi-shield-check</v-icon
                                >
                                <div>
                                    <p class="statistic-caption mb-1">
                                        {{ $t('message.qualifiedApplicants.sheet.listApplicants')}}
                                    </p>
                                    <p class="statistic-value mb-0">
                                        {{ studentsNumber }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="
                                    statistic statistic--green
                                    align-center
                                    py-0
                                "
                            >
                                <v-icon class="statistic-icon" size="33.33"
                                    >mdi-check-circle</v-icon
                                >
                                <div>
                                    <p class="statistic-caption mb-1">
                                        {{ $t('message.qualifiedApplicants.sheet.transferred')}}
                                    </p>
                                    <p class="statistic-value mb-0">
                                        {{ transferCompleteNumber }}
                                    </p>
                                </div>
                            </div>
                            <div class="statistic statistic--yellow">
                                <v-icon class="statistic-icon" size="33.33"
                                    >mdi-clock</v-icon
                                >
                                <div>
                                    <p class="statistic-caption mb-1">
                                        {{ $t('message.qualifiedApplicants.sheet.onProcess')}}
                                    </p>
                                    <p class="statistic-value mb-0">
                                        {{ waitTransferNumber }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="12" v-if="acceptForm">
                        <v-row class="my-4 px-5">
                            <v-col cols="5">
                                <v-text-field
                                    v-model="keyword"
                                    outlined
                                    :placeholder="$t('message.qualifiedApplicants.searchByApplicantsNameOnly')"
                                    prepend-inner-icon="mdi-magnify"
                                    hide-details
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="1" class="px-0">
                                <v-btn
                                    v-if="keyword.length > 0"
                                    color="primary"
                                    outlined
                                    elevation="0"
                                    @click="search"
                                    width="90"
                                >
                                    {{ $t('message.adminPage.search') }}
                                </v-btn>
                                <v-btn
                                    v-else
                                    color="gray"
                                    outlined
                                    elevation="0"
                                    @click="search"
                                    width="90"
                                >
                                    {{ $t('message.adminPage.search') }}
                                </v-btn>
                            </v-col>

                            <v-col cols="3">
                                <v-select
                                    v-model="selectedStudentYear"
                                    @change="changeStudentYear"
                                    outlined
                                    :items="studentYear"
                                    :item-text="`student_year_name_${locale}`"
                                    item-value="value"
                                    hide-details
                                    prepend-inner-icon="mdi-filter-variant"
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    v-model="selectedAdmissionStatus"
                                    @change="changeAdmissionStatus"
                                    outlined
                                    :items="admissionStatuses"
                                    :item-text="`text_${locale}`"
                                    item-value="value"
                                    hide-details
                                    prepend-inner-icon="mdi-filter-variant"
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col
                                cols="12"
                                lg="12"
                                class="d-flex justify-space-between"
                            >
                                <div class="sarabun-16" style="color: red">
                                    <label
                                        class="pa-0"
                                        v-if="classrooms.length == 0"
                                        >{{ $t('message.qualifiedApplicants.createClassroom') }}
                                        <a
                                            href="https://schooney-dev-01.azurewebsites.net/academic-year/classroom"
                                            class="
                                                prompt-underline
                                                text-decoration-underline
                                            "
                                            >{{ $t('message.qualifiedApplicants.guide.content7') }}</a
                                        ></label
                                    >
                                </div>
                                <a
                                    class="
                                        prompt-underline
                                        text-decoration-underline
                                    "
                                    v-if="selected.length>0"
                                    @click="onClickButton"
                                >
                                    {{ $t('message.qualifiedApplicants.createStudentID') }}
                                </a>
                            </v-col>
                        </v-row>
                        <v-data-table
                            ref="table"
                            v-model="selected"
                            :headers="headers"
                            :options.sync="options"
                            @toggle-select-all="selectAll"
                            :items="students.filter(item => item.registration_status == 'SUCCESSFUL_ENROLLMENT')"
                            class="elevation-0 mx-0 pa-0"
                            :single-select="singleSelect"
                            color="orange"
                            :footer-props="{
                                'items-per-page-options':[50, 100, 500, 1000, -1],
                                'items-per-page-text': $t('message.common.pagination.row_per_page'),
                                'page-text': `${options.page || 1}`+' '+$t('message.common.pagination.of')+' '+`${totalTablePage}`,
                            }"
                            show-select
                            style="color: #37323c;"
                        >
                            
                            <!-- eslint-disable-next-line -->
                            <template v-slot:item.data-table-select="{ item }">
                                <v-simple-checkbox 
                                    :value="selected.find((i) => i.id == item.id) == null ? false : true"
                                    @input="selected.find((i) => i.id == item.id) == null ? selected.push(item) : selected.pop(item)"
                                    class="pa-0 ma-0"
                                    hide-details
                                    color="orange"
                                    :disabled="item.status == 'SUCCESS'">
                                </v-simple-checkbox>
                            </template>
                             <!-- eslint-disable-next-line -->
                            <template #item.name="{item}">
                                <div>
                                    {{item?.[`name_${locale}`]}}
                                </div>
                                
                            </template>
                             <!-- eslint-disable-next-line -->
                            <template #item.program="{item}">
                                <div>
                                    {{item?.program?.[`program_name_${locale}`]}}
                                </div>
                                
                            </template>
                             <!-- eslint-disable-next-line -->
                            <template #item.grade="{item}">
                                <div >
                                    {{item?.grade?.[`student_year_name_${locale}`]}}
                                </div>
                                
                            </template>

                            
                             <!-- eslint-disable-next-line -->
                            <template #item.student_id="{item}">
                                <v-text-field
                                            class="my-1"
                                            v-model="item.student_id"
                                            outlined
                                            hide-details="auto"
                                            dense
                                            :placeholder="$t('message.qualifiedApplicants.input.pleaseFill')"
                                            :disabled="
                                                !checkDisabled(item.name)
                                            "
                                            style="width: 110px"
                                            :rules="[
                                                (v) =>
                                                    (!!v ||
                                                    !checkDisabled(item.name)) ||
                                                    'message.qualifiedApplicants.input.error',
                                                (v) =>
                                                    (!!v && checkIsSameOther(v, item.name) || !checkDisabled(item.name)) || 
                                                    'message.qualifiedApplicants.input.errorExist',
                                            ]"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template>
                                </v-text-field>
                            </template>

                             <!-- eslint-disable-next-line -->
                            <template #item.room="{item}">
                                <v-text-field
                                    v-if="item.classroom"
                                    class="my-1"
                                    v-model="item.classroom[`room_name_${locale}`]"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    :disabled="
                                        !checkDisabled(item.name)
                                    "
                                    style="width: 110px"
                                ></v-text-field>
                                <v-select 
                                    v-else
                                    class="my-1"
                                    v-model="item.room"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    :placeholder="$t('message.qualifiedApplicants.input.select')"
                                    :items="
                                        classrooms.filter((classroom) =>
                                            classroom.text_en.includes(
                                                `G ${item.grade.value}`
                                            )
                                        )
                                    "
                                    :item-text="`text_${locale}`"
                                    item-value="value"
                                    :disabled="
                                        !checkDisabled(item.name)
                                    "
                                    style="width: 110px"
                                    :rules="[
                                        (v) =>
                                            (!!v || !checkDisabled(item.name)) ||
                                            'message.qualifiedApplicants.input.error',
                                    ]"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template>
                                </v-select>
                            </template>

                             <!-- eslint-disable-next-line -->
                            <template #item.status="{item}">
                                <span v-if="item.status == 'SUCCESS'">
                                            <v-icon
                                                left
                                                class="icon--green"
                                                small
                                                >mdi-check-circle</v-icon
                                            >{{ $t('message.qualifiedApplicants.transferred') }}
                                        </span>
                                        <span v-else-if="item.status == 'WAIT' || item.status == null">
                                            {{ $t('message.qualifiedApplicants.onProcess') }}
                                        </span>
                                        <span v-else> - </span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import router from "@/router";
import { AdmissionStatusEnum } from "@/constants";
import * as services from "@/services";
import i18n from "@/i18n";

export default {
    name: "QualifiedList",
    data() {
        return {
            // table prop
            options: {},
            singleSelect: false,
            sortDesc: true,

            // static data
            studentYear: [],
            admissionStatuses: AdmissionStatusEnum,
            classrooms: [],
            defaultStudentYear: {
                id: null,
                student_year_name_en: "All Grade",
                student_year_name_th: "ระดับชั้นทั้งหมด",
                value: null,
            },

            // condition prop
            dialog: false,
            hasList: false,
            fetchDataQueue: 0,

            // query params
            keyword: "",
            page: 1,
            pageSize: 50,
            selectedAdmissionStatus: null,
            selectedStudentYear: null,

            // table select data
            selected: [],
            tempSelected: [],
            
            // fetch data
            students: [],
            totalStudent: 0,
        };
    },
    props: {
        // condition
        acceptForm: Boolean,
        validateData: Boolean,
        toggleUpdateStudent: Boolean,

        // data
        registerFormId: Number,
        registerPlan: Array,
        semesterYear: String,
        
        student_id_pattern: Array,

        // trigger fetch
        trigger_student_id_pattern: Boolean
    },
    computed: {
        headers(){
            return [
                { text: i18n.t('message.qualifiedApplicants.table.fullname'), sortable: true, value: "name", },
                { text: i18n.t('message.qualifiedApplicants.table.curriculum'), value: "program" },
                { text: i18n.t('message.qualifiedApplicants.table.grade'), value: "grade" },
                { text: i18n.t('message.qualifiedApplicants.table.studentID'), value: "student_id" },
                { text: i18n.t('message.qualifiedApplicants.table.classroom'), value: "room" },
                { text: i18n.t('message.qualifiedApplicants.table.status'), value: "status" },
            ]
        },
        locale(){
            return i18n.locale;
        },
        studentsNumber() {
            return this.students.length || "0";
        },
        transferCompleteNumber() {
            return (
                this.students.filter((item) => item.status == "SUCCESS")
                    .length || "0"
            );
        },
        waitTransferNumber() {
            return (
                this.students.filter((item) => item.status == "WAIT").length ||
                "0"
            );
        },
        totalTablePage(){
            if(this.totalStudent == 0)
                return 1
            return Math.ceil(this.totalStudent/this.pageSize);
        }
    },
    methods: {
        // Fetch search
        search() {
            const query = this.prepareQuery();
            router.push({
                path: `/registration/qualified`,
                query: { ...query, keyword: this.keyword },
            });

            // Fetch student
            this.getStudentQualifyFromQuery();
        },
        checkIsSameOther(value, name){
            for (var i = 0; i < this.students.length; i++) {
                if (this.students[i]?.student_id == value && this.students[i]?.name != name) {
                    return false;
                }
            }
            return true
        },
        changeStudentYear(value) {
            const query = this.prepareQuery();
            router.push({
                path: `/registration/qualified`,
                query: { ...query, student_year: value },
            });

            // student & classroom
            this.fetchDataInfo()
        },
        changeAdmissionStatus(value) {
            const query = this.prepareQuery();
            router.push({
                path: `/registration/qualified`,
                query: { ...query, admission_status: value },
            });
            // fetch students
            this.getStudentQualifyFromQuery();
        },

        // api
        async getClassroom() {
            try{
                this.loadingUpdate(1);

                // Get all student year from register form
                const studentYear = [];
                    // Select all
                if (this.selectedStudentYear == null) {
                    for (let i = 0; i < this.studentYear.length; i++) {
                        if (this.studentYear[i].value != null)
                            studentYear.push(this.studentYear[i].value);
                    }
                }
                    // Select target student year  
                else {
                    studentYear.push(
                        this.studentYear.find(
                            (item) => item.id == this.selectedStudentYear
                        ).value
                    );
                }

                // check semester year is valid
                if (this.semesterYear != null) {
                    // Fetch Classroom form target semester year
                    const { data: { data }} = await services.getClassroomFromCore(
                                                this.semesterYear, 
                                                {
                                                    studentYear: studentYear,
                                                });
                    this.classrooms = data;
                } else {
                    // Fetch all classroom form 2565
                    const {
                        data: { data },
                    } = await services.getClassroomFromCore("2565", {
                        studentYear: studentYear,
                    });
                    this.classrooms = data;
                }
            }
            catch(err){
                console.log(err)
            }
            finally{
                this.loadingUpdate(-1);
            }
        },
        async getStudentQualifyFromQuery() {
            try {
                // Fetch Qualify Student 
                this.loadingUpdate(1);
                let query = this.prepareQuery();
                query = { ...query, register_form_config: this.registerFormId };
                const { data: { data } } = await services.getStudentQualify(query);

                await this.prepareStudentData(data.students);
                
                this.totalStudent = data.total_number
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingUpdate(-1);
            }
        },

        // prepare data
        async prepareStudentData(students) {
            this.students = [];
            // Prepare student object to show on table
            for (let i = 0; i < students.length; i++) {
                let newStudent = {
                    id: students[i].id,
                    name_th: `${students[i].student_detail.prefix_id.text_th} ${students[i].student_detail.name_th} ${students[i].student_detail.surname_th}`,
                    name_en: `${students[i].student_detail.prefix_id.text_en} ${students[i].student_detail.name_en} ${students[i].student_detail.surname_en}`,
                    program: students[i].register_plan.program,
                    grade: students[i].register_plan.student_year,
                    student_id: students[i].student_admission_detail.student_no,
                    room: Number(students[i].student_admission_detail.room) || null,
                    status: students[i].student_admission_detail
                        .admission_status,
                    classroom: students[i].student_admission_detail?.classroom || null,
                    registration_status: students[i].registration_status || null,
                };
                await this.students.push(newStudent);
            }
        },
        prepareQuery() {
            return {
                keyword: this.keyword || "",
                student_year: this.selectedStudentYear || "",
                admission_status: this.selectedAdmissionStatus || "",
                page: this.page || 1,
                page_size: this.pageSize || 50,
            };
        },

        // main caller
        async fetchDataInfo(){
            try{
                this.loadingUpdate(1)
                // fetch students
                await this.getStudentQualifyFromQuery();
                // fetch classroom
                await this.getClassroom();
            }
            finally{
                this.loadingUpdate(-1)
            }
        },
        async setUpInitFetch() {
            try{
                this.loadingUpdate(1)
                // Update and prepare data when change params
                this.fetchDataQueue++;
                // Clear search and form
                const query = this.prepareQuery();
                router.push({
                    path: `/registration/qualified`,
                    query: { ...query },
                });
    
                // Init student year
                this.studentYear = [];
                await this.studentYear.push(this.defaultStudentYear);
    
                // Init Plan
                await this.registerPlan.map((plan) => {
                    let studentYearSelector = {};
                    studentYearSelector = { ...plan.student_year};
                    if(!this.studentYear.find((item) => item.value == studentYearSelector?.value))
                        this.studentYear.push(studentYearSelector);
                });
    
                // Clear selected student year
                this.selectedStudentYear = null;
    
                // Setup fetch student data
                this.fetchDataInfo()
                
            }
            finally{
                this.fetchDataQueue--;
                this.loadingUpdate(-1)
            }
        },

        // etc.
        activeTHtagIcon() {
            const elem = document.getElementsByClassName("text-start");
            for (let i = 0; i < elem.length; i++) {
                elem[i].classList.add("active");
            }
        },
        onClickButton() {
            // open generate student id popup
            this.dialog = !this.dialog;
            this.$emit("onClickGenerate", this.dialog);
        },
        checkDisabled(item) {
            for (var i = 0; i < this.selected.length; i++) {
                if (this.selected[i].name == item) {
                    return true;
                }
            }
        },
        selectAll(values) {
            let itemsOnPage = values.items
            itemsOnPage = itemsOnPage.filter((item) => item.status == "WAIT")

            // for focus single page
            if(values.value == true){
                let isMatch = true;
                if(itemsOnPage.length == 0){
                    this.selected = []
                }
                else{
                    for(let i = 0 ; i < itemsOnPage.length ; i++){
                        const item = this.tempSelected.find((item) => item.id == itemsOnPage[i].id)
                        if(item == null){
                            // didn't selected all
                            isMatch = false
                            break;
                        }
                    }
                    if(isMatch){
                        // already select all
                        // deselect
                        this.selected = []
                    }
                    else{
                        // select all
                        this.selected = itemsOnPage
                    }
                }
            }
            
        },
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },

        // generate data
        fillStudentID(){
            let running = 0;
            for (var j = 0; j < this.selected.length; j++) {
                let stringBuffer = "";
                for (var i = 0; i < this.student_id_pattern.length; i++) {
                    if (this.student_id_pattern[i].mode != "null") {
                        if (this.student_id_pattern[i].mode == "fix") {
                            stringBuffer = stringBuffer + this.student_id_pattern[i].text;
                        } else {
                            var increase_value = parseInt(this.student_id_pattern[i].text) + j + running;
                            var new_val = this.addZero(
                                increase_value,
                                this.student_id_pattern[i].text + "0"
                            );
                            stringBuffer = stringBuffer + new_val;
                        }
                    }
                }
                const targetDessert = this.students.findIndex((item) => item.id == this.selected[j].id)
                let isOnlyFix = this.student_id_pattern.find((item) => item.mode == "generate")
                if(isOnlyFix != null){
                    let checkItem = this.students.find((item) => item.student_id == stringBuffer)
                    
                    if(checkItem){
                        if(checkItem.status == "SUCCESS"){
                            j--
                            running++
                            continue
                        }
                        else{
                            if(checkItem.id != this.selected[j].id)
                            {
                                j--
                                running++
                                continue
                            }
                        }
                    }

                }
                this.students[targetDessert].student_id = stringBuffer
            }
        },
        addZero(num, digitNumber) {
            var txtVal = "";
            var zeroTxt = "";
            var newDigit = digitNumber.toString().length - 1;
            if (num.toString().length == newDigit) {
                txtVal = num.toString();
            } else {
                for (
                    var digitCount = num.toString().length;
                    digitCount < newDigit;
                    digitCount++
                ) {
                    zeroTxt = zeroTxt + "0";
                }
                txtVal = zeroTxt + num.toString();
            }
            return txtVal;
        },

        
    },
    watch: {
        toggleUpdateStudent() {
            // send selected students
            let selectedData = []
            for(let i = 0 ; i < this.selected.length ; i++){
                selectedData.push({
                    grade: this.selected[i].grade,
                    id: this.selected[i].id,
                    name: this.selected[i].name,
                    program: this.selected[i].program,
                    room: this.classrooms.find(item => item.value == this.selected[i].room),
                    status: this.selected[i].status,
                    student_id: this.selected[i].student_id
                })
            }

            this.$emit("getSelectedStudents", selectedData, this.students);
        },
        options:{
            handler(value) {
                const { page, itemsPerPage } = value;
                this.page = page;
                this.pageSize = itemsPerPage;
                const query = this.prepareQuery();
                const path = this.$route.path;
                router.push({
                    path,
                    query,
                });
            },
            deep: true,
        },
        selected() {
            this.tempSelected = this.selected
            this.$emit("fakeUpdateSelected", this.tempSelected)
        },
        // Props
        acceptForm() {
            if (this.acceptForm == true && this.fetchDataQueue == 0) {
                this.setUpInitFetch();
            }
            else{
                this.selected = []
            }
        },
        registerPlan() {
            if (this.acceptForm == true && this.fetchDataQueue == 0) {
                this.setUpInitFetch();
            }
        },
        semesterYear() {
            if (this.acceptForm == true && this.fetchDataQueue == 0) {
                this.setUpInitFetch();
            }
        },
        registerFormId() {
            if (this.acceptForm == true && this.fetchDataQueue == 0) {
                this.setUpInitFetch();
            }
        },
        validateData() {
            this.$emit("getListValidate", this.$refs.formQualifiedList.validate()) ;
        },
        trigger_student_id_pattern(){
            this.fillStudentID()
        }
        
    },
};
</script>

<style scoped lang="scss">

th > i {
    margin-top: -10px;
}
.statistic-panel {
    display: flex;
    gap: 16px;
}
.statistic {
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    padding: 16px;
    /* width: 200px; */
    flex: 1;
    border: 1px solid #fff;
    border-radius: 10px;
}

.statistic-icon {
    font-size: 36px;
}
.statistic-caption {
    font-family: "Prompt", sans-serif;
    font-size: 14px;
    margin-bottom: 0;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.statistic-value {
    font-family: "Prompt", sans-serif;
    font-size: 24px;
    margin-bottom: 0;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.statistic--blue {
    background-color: rgba(111, 162, 204, 0.3);
    border-color: #7fa2cc;
}

.statistic--blue > .statistic-icon {
    color: #7fa2cc;
}

.statistic--green {
    background-color: rgba(102, 220, 183, 0.3);
    border-color: rgb(102, 220, 183);
}

.statistic--green > .statistic-icon {
    color: #66dcb7;
}

.statistic--browny {
    background-color: rgba(153, 91, 0, 0.3);
    border-color: rgb(153, 91, 0);
}

.statistic--browny > .statistic-icon {
    color: #995b00;
}

.statistic--yellow {
    background-color: rgba(255, 193, 102, 0.3);
    border-color: rgb(255, 193, 102);
}

.statistic--yellow > .statistic-icon {
    color: #ffc166;
}

.form--inline {
    display: flex;
}

.form--gap-xl {
    gap: 32px;
}

.form--gap-md {
    gap: 16px;
}

.form__item--full {
    flex: 1;
}
.form__item--right {
    text-align: right;
}


</style>
